<template>
  <div class="bankmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="radiobut" v-if="permission.contract_audit">
      <el-badge :value="examinelist" class="item">
        <el-radio-group v-model="margintap">
          <el-radio-button label="0">合同管理</el-radio-button>

          <el-radio-button label="1">审核列表</el-radio-button>
        </el-radio-group>
        </el-badge
      >
    </div>
    <!-- <div class="topcrud" v-if="!permission.contract_audit">
      <div class="messagetitle"><span>合同管理</span></div>
    </div> -->
    <Manage v-if="margintap == 0" @rowdata="rowdata" :files="files" />
    <Examinelist v-if="margintap == 1" @rowdata="rowdata" :files="files" />
  </div>
</template>

<script>
import * as api from "@/api/zd/contract";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Manage from "./components/manageindex";
import Examinelist from "./components/examinelist";
import { mapGetters } from "vuex";

export default {
  name: "bankmanage",
  data() {
    return {
      margintap: 0,
      examinelist: 0,

      files: []
    };
  },
  components: {
    TagsCloud,
    Manage,
    Examinelist
  },
  created() {
    this.onload();
  },
  computed: {
    ...mapGetters(["permission"])
  },
  methods: {
    onload() {
      api
        .getListcontract({
          firstNum: 0,
          num: 10
        })
        .then(res => {
          
          this.examinelist = res.data.data.shlb;
          this.authority = res.data.data.hasAuditRight;
        })
        .catch(res => {
          
        });
    },
    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },
    cloudTages(data) {
      this.files = data;
      
    }
  }
};
</script>
<style lang="scss" scoped>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      // font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  /deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
}
}
</style>
